// // import { Suspense, lazy, useEffect } from "react";
// // import "./App.css";
// // import { BrowserRouter, Route, Routes } from "react-router-dom";
// // import { ErrorBoundary } from "react-error-boundary";
// // import Lottie from "lottie-react";
// // import Header from "./components/Header";
// // import Footer from "./components/Footer";
// // import ErrorFallback from "./components/ErrorFallback";
// // import PageNotFound from "./pages/PageNotFound";
// // import loading from "./assets/animations/loading.json";
// // import { useDispatch, useSelector } from "react-redux";
// // import ProductDetailPopup from "./components/ProductDetailPopup";
// // import { Toaster, toast } from "react-hot-toast";
// // import PrivateRoute from "./pages/PrivateRoute";
// // import {
// //   handleLogout,
// //   loginAllTabsEventListener,
// //   logoutAllTabsEventListener,
// // } from "./redux/GlobalStates";
// // import {
// //   handleGetBanners,
// //   handleGetCategory,
// //   handleGetContactUsDetails,
// //   handleGetSubCategory,
// // } from "./redux/GetContentSlice";
// // import { handleGetCart } from "./redux/CartSlice";
// // import {
// //   handleGetAllProducts,
// //   handleGetNewArrivals,
// //   handleGetTopSellers,
// // } from "./redux/ProductSlice";
// // import {
// //   handleGetVisitCount,
// //   handleLogoutReducer,
// //   handleRegisterUser,
// // } from "./redux/AuthSlice";
// // import ScrollToTop from "./components/ScrollToTop";
// // import { OrderAllTabsEventListener } from "./redux/OrderSlice";

// // const Home = lazy(() => import("./pages/Home"));
// // const PrivayPolicy = lazy(() => import("./pages/PrivayPolicy"));
// // const ContactUs = lazy(() => import("./pages/ContactUs"));
// // const AboutUs = lazy(() => import("./pages/AboutUs"));
// // const Signin = lazy(() => import("./pages/Signin"));
// // const Signup = lazy(() => import("./pages/Signup"));
// // const Cart = lazy(() => import("./pages/Cart"));
// // const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
// // const ResetPassword = lazy(() => import("./pages/ResetPassword"));
// // const ProductListing = lazy(() => import("./pages/ProductListing"));
// // const ShippingAndFreight = lazy(() => import("./pages/ShippingAndFreight"));
// // const MyAccount = lazy(() => import("./pages/MyAccount"));
// // const SpecialOrder = lazy(() => import("./pages/SpecialOrder"));
// // const Favourites = lazy(() => import("./pages/Favourites"));

// // function App() {
// //   const { showProductDetailsPopup } = useSelector(
// //     (state) => state.globalStates
// //   );

// //   const { token, user } = useSelector((state) => state.Auth);

// //   const dispatch = useDispatch();

// //   useEffect(() => {
// //     dispatch(loginAllTabsEventListener());
// //     dispatch(logoutAllTabsEventListener());
// //     dispatch(OrderAllTabsEventListener());
// //     dispatch(handleGetCategory());
// //     dispatch(handleGetSubCategory());
// //     dispatch(handleGetNewArrivals({ token }));
// //     dispatch(handleGetBanners());
// //     dispatch(handleGetContactUsDetails());
// //     dispatch(handleGetAllProducts({ token }));
// //     const response = dispatch(handleGetTopSellers({ token }));
// //     if (response) {
// //       response.then((res) => {
// //         if (
// //           res.payload?.status === "fail" &&
// //           (res.payload?.message === "Please login first." ||
// //             res.payload?.message === "Please provide authentication token.")
// //         ) {
// //           dispatch(handleLogoutReducer());
// //           dispatch(handleLogout());
// //         } else if (res.payload?.status === "fail") {
// //           toast.error(res.payload?.message);
// //         }
// //       });
// //     }

// //     if (user !== null) {
// //       const response = dispatch(handleGetVisitCount({ token }));
// //       if (response) {
// //         response.then((res) => {
// //           if (
// //             res.payload?.status === "fail" &&
// //             (res.payload?.message === "Please login first." ||
// //               res.payload?.message === "Please provide authentication token.")
// //           ) {
// //             dispatch(handleLogoutReducer());
// //             dispatch(handleLogout());
// //           } else if (res.payload?.status === "fail") {
// //             toast.error(res.payload?.message);
// //           }
// //         });
// //       }
// //     }
// //     if (!window.navigator.onLine) {
// //       toast.error("Check your internet connection", { duration: "5000" });
// //     }
// //   }, []);

// //   useEffect(() => {
// //     if (user !== null) {
// //       const response = dispatch(handleGetCart({ token }));
// //       if (response) {
// //         response.then((res) => {
// //           if (
// //             res.payload?.status === "fail" &&
// //             (res.payload?.message === "Please login first." ||
// //               res.payload?.message === "Please provide authentication token.")
// //           ) {
// //             dispatch(handleLogoutReducer());
// //             dispatch(handleLogout());
// //           } else if (res.payload?.status === "fail") {
// //             toast.error(res.payload?.message);
// //           } else if (res.payload?.status === "success") {
// //             localStorage.setItem(
// //               "cartItems",
// //               JSON.stringify(res.payload.items)
// //             );
// //           }
// //         });
// //       }
// //     }
// //   }, [user, token]);
   

// //   return (
// //     <BrowserRouter>
// //       <ErrorBoundary
// //         FallbackComponent={ErrorFallback}
// //         onReset={() => {
// //           window.location.reload();
// //         }}
// //       >
// //         <ScrollToTop />

// //         <Suspense
// //           fallback={
// //             <div className="relative top-0 left-0 w-screen h-screen">
// //               <Lottie
// //                 style={{
// //                   pointerEvents: "none",
// //                   height: "300px",
// //                   width: "300px",
// //                 }}
// //                 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-screen h-full"
// //                 animationData={loading}
// //                 loop
// //               />
// //             </div>
// //           }
// //         >
// //           {showProductDetailsPopup && <ProductDetailPopup />}
// //           <Header />
// //           <Routes>
// //             <Route path="/" element={<Home />} caseSensitive />
// //             <Route path="/about-us" element={<AboutUs />} caseSensitive />
// //             <Route path="/contact-us" element={<ContactUs />} caseSensitive />
// //             <Route
// //               path="/privacy-policy"
// //               element={<PrivayPolicy />}
// //               caseSensitive
// //             />

// //             <Route path="/sign-in" element={<Signin />} caseSensitive />
// //             <Route path="/sign-up" element={<Signup />} caseSensitive />
// //             <Route
// //               path="/cart"
// //               element={
// //                 <PrivateRoute>
// //                   <Cart />
// //                 </PrivateRoute>
// //               }
// //               caseSensitive
// //             />
// //             <Route
// //               path="/product-listing/:title"
// //               element={<ProductListing />}
// //               caseSensitive
// //             />

// //             <Route
// //               path="/favourites"
// //               element={
// //                 <PrivateRoute>
// //                   <Favourites />
// //                 </PrivateRoute>
// //               }
// //               caseSensitive
// //             />
// //             <Route
// //               path="/special-order"
// //               element={<SpecialOrder />}
// //               caseSensitive
// //             />
// //             <Route
// //               path="/forgot-password"
// //               element={<ForgotPassword />}
// //               caseSensitive
// //             />
// //             <Route
// //               path="/reset-password"
// //               element={<ResetPassword />}
// //               caseSensitive
// //             />
// //             <Route
// //               path="/my-account"
// //               element={
// //                 <PrivateRoute>
// //                   <MyAccount />
// //                 </PrivateRoute>
// //               }
// //               caseSensitive
// //             />
// //             <Route
// //               path="/shipping-&-freight"
// //               element={<ShippingAndFreight />}
// //               caseSensitive
// //             />
// //             <Route path="/*" element={<PageNotFound />} />
// //           </Routes>
// //           <Footer />
// //         </Suspense>
// //       </ErrorBoundary>
// //     </BrowserRouter>
// //   );
// // }

// // export default App;


// import { Suspense, lazy, useEffect } from "react";
// import "./App.css";
// import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
// import { ErrorBoundary } from "react-error-boundary";
// import Lottie from "lottie-react";
// import Header from "./components/Header";
// import Footer from "./components/Footer";
// import ErrorFallback from "./components/ErrorFallback";
// import PageNotFound from "./pages/PageNotFound";
// import loading from "./assets/animations/loading.json";
// import { useDispatch, useSelector } from "react-redux";
// import ProductDetailPopup from "./components/ProductDetailPopup";
// import { Toaster, toast } from "react-hot-toast";
// import PrivateRoute from "./pages/PrivateRoute";
// import {
//   handleLogout,
//   loginAllTabsEventListener,
//   logoutAllTabsEventListener,
// } from "./redux/GlobalStates";
// import {
//   handleGetBanners,
//   handleGetCategory,
//   handleGetContactUsDetails,
//   handleGetSubCategory,
// } from "./redux/GetContentSlice";
// import { handleGetCart } from "./redux/CartSlice";
// import {
//   handleGetAllProducts,
//   handleGetNewArrivals,
//   handleGetTopSellers,
// } from "./redux/ProductSlice";
// import {
//   handleGetVisitCount,
//   handleLogoutReducer,
//   handleRegisterUser,
// } from "./redux/AuthSlice";
// import ScrollToTop from "./components/ScrollToTop";
// import { OrderAllTabsEventListener } from "./redux/OrderSlice";

// const Home = lazy(() => import("./pages/Home"));
// const PrivayPolicy = lazy(() => import("./pages/PrivayPolicy"));
// const ContactUs = lazy(() => import("./pages/ContactUs"));
// const AboutUs = lazy(() => import("./pages/AboutUs"));
// const Signin = lazy(() => import("./pages/Signin"));
// const Signup = lazy(() => import("./pages/Signup"));
// const Cart = lazy(() => import("./pages/Cart"));
// const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
// const ResetPassword = lazy(() => import("./pages/ResetPassword"));
// const ProductListing = lazy(() => import("./pages/ProductListing"));
// const ShippingAndFreight = lazy(() => import("./pages/ShippingAndFreight"));
// const MyAccount = lazy(() => import("./pages/MyAccount"));
// const SpecialOrder = lazy(() => import("./pages/SpecialOrder"));
// const Favourites = lazy(() => import("./pages/Favourites"));

// // ────────────────────────────────────────────────
// // Activity tracking function
// // ────────────────────────────────────────────────
// const trackActivity = () => {
//   fetch('/api/track-user-activity', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     credentials: 'include',
//   })
//     .then((res) => {
//       if (!res.ok) console.warn('Activity track failed:', res.status);
//     })
//     .catch((err) => console.log('Activity track failed:', err));
// };

// // ────────────────────────────────────────────────
// // Naya component jo Router ke andar hai
// // ────────────────────────────────────────────────
// function ActivityTracker() {
//   const token = localStorage.getItem('token'); // or wherever you store JWT
//     if (!token) return; // not logged in — skip
 
//     fetch('/activity/click', {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': token
//         }
//     }).catch(() => {});
// }

// function App() {
//   const { showProductDetailsPopup } = useSelector((state) => state.globalStates);
//   const { token, user } = useSelector((state) => state.Auth);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(loginAllTabsEventListener());
//     dispatch(logoutAllTabsEventListener());
//     dispatch(OrderAllTabsEventListener());
//     dispatch(handleGetCategory());
//     dispatch(handleGetSubCategory());
//     dispatch(handleGetNewArrivals({ token }));
//     dispatch(handleGetBanners());
//     dispatch(handleGetContactUsDetails());
//     dispatch(handleGetAllProducts({ token }));
//     const response = dispatch(handleGetTopSellers({ token }));
//     if (response) {
//       response.then((res) => {
//         if (
//           res.payload?.status === "fail" &&
//           (res.payload?.message === "Please login first." ||
//             res.payload?.message === "Please provide authentication token.")
//         ) {
//           dispatch(handleLogoutReducer());
//           dispatch(handleLogout());
//         } else if (res.payload?.status === "fail") {
//           toast.error(res.payload?.message);
//         }
//       });
//     }

//     if (user !== null) {
//       const response = dispatch(handleGetVisitCount({ token }));
//       if (response) {
//         response.then((res) => {
//           if (
//             res.payload?.status === "fail" &&
//             (res.payload?.message === "Please login first." ||
//               res.payload?.message === "Please provide authentication token.")
//           ) {
//             dispatch(handleLogoutReducer());
//             dispatch(handleLogout());
//           } else if (res.payload?.status === "fail") {
//             toast.error(res.payload?.message);
//           }
//         });
//       }
//     }
//     if (!window.navigator.onLine) {
//       toast.error("Check your internet connection", { duration: "5000" });
//     }
//   }, []);

//   useEffect(() => {
//     if (user !== null) {
//       const response = dispatch(handleGetCart({ token }));
//       if (response) {
//         response.then((res) => {
//           if (
//             res.payload?.status === "fail" &&
//             (res.payload?.message === "Please login first." ||
//               res.payload?.message === "Please provide authentication token.")
//           ) {
//             dispatch(handleLogoutReducer());
//             dispatch(handleLogout());
//           } else if (res.payload?.status === "fail") {
//             toast.error(res.payload?.message);
//           } else if (res.payload?.status === "success") {
//             localStorage.setItem(
//               "cartItems",
//               JSON.stringify(res.payload.items)
//             );
//           }
//         });
//       }
//     }
//   }, [user, token]);

//   return (
//     <BrowserRouter>
//       <ErrorBoundary
//         FallbackComponent={ErrorFallback}
//         onReset={() => {
//           window.location.reload();
//         }}
//       >
//         <ScrollToTop />

//         {/* ← Yeh line add kar do – Router ke andar hai to useLocation safe rahega */}
//         <ActivityTracker />

//         <Suspense
//           fallback={
//             <div className="relative top-0 left-0 w-screen h-screen">
//               <Lottie
//                 style={{
//                   pointerEvents: "none",
//                   height: "300px",
//                   width: "300px",
//                 }}
//                 className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-screen h-full"
//                 animationData={loading}
//                 loop
//               />
//             </div>
//           }
//         >
//           {showProductDetailsPopup && <ProductDetailPopup />}
//           <Header />
//           <Routes>
//             <Route path="/" element={<Home />} caseSensitive />
//             <Route path="/about-us" element={<AboutUs />} caseSensitive />
//             <Route path="/contact-us" element={<ContactUs />} caseSensitive />
//             <Route
//               path="/privacy-policy"
//               element={<PrivayPolicy />}
//               caseSensitive
//             />

//             <Route path="/sign-in" element={<Signin />} caseSensitive />
//             <Route path="/sign-up" element={<Signup />} caseSensitive />
//             <Route
//               path="/cart"
//               element={
//                 <PrivateRoute>
//                   <Cart />
//                 </PrivateRoute>
//               }
//               caseSensitive
//             />
//             <Route
//               path="/product-listing/:title"
//               element={<ProductListing />}
//               caseSensitive
//             />

//             <Route
//               path="/favourites"
//               element={
//                 <PrivateRoute>
//                   <Favourites />
//                 </PrivateRoute>
//               }
//               caseSensitive
//             />
//             <Route
//               path="/special-order"
//               element={<SpecialOrder />}
//               caseSensitive
//             />
//             <Route
//               path="/forgot-password"
//               element={<ForgotPassword />}
//               caseSensitive
//             />
//             <Route
//               path="/reset-password"
//               element={<ResetPassword />}
//               caseSensitive
//             />
//             <Route
//               path="/my-account"
//               element={
//                 <PrivateRoute>
//                   <MyAccount />
//                 </PrivateRoute>
//               }
//               caseSensitive
//             />
//             <Route
//               path="/shipping-&-freight"
//               element={<ShippingAndFreight />}
//               caseSensitive
//             />
//             <Route path="/*" element={<PageNotFound />} />
//           </Routes>
//           <Footer />
//         </Suspense>
//       </ErrorBoundary>
//     </BrowserRouter>
//   );
// }

// export default App;

import { Suspense, lazy, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import Lottie from "lottie-react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ErrorFallback from "./components/ErrorFallback";
import PageNotFound from "./pages/PageNotFound";
import loading from "./assets/animations/loading.json";
import { useDispatch, useSelector } from "react-redux";
import ProductDetailPopup from "./components/ProductDetailPopup";
import { Toaster, toast } from "react-hot-toast";
import PrivateRoute from "./pages/PrivateRoute";
import {
  handleLogout,
  loginAllTabsEventListener,
  logoutAllTabsEventListener,
} from "./redux/GlobalStates";
import {
  handleGetBanners,
  handleGetCategory,
  handleGetContactUsDetails,
  handleGetSubCategory,
} from "./redux/GetContentSlice";
import { handleGetCart } from "./redux/CartSlice";
import {
  handleGetAllProducts,
  handleGetNewArrivals,
  handleGetTopSellers,
} from "./redux/ProductSlice";
import {
  handleGetVisitCount,
  handleLogoutReducer,
  handleRegisterUser,
} from "./redux/AuthSlice";
import ScrollToTop from "./components/ScrollToTop";
import { OrderAllTabsEventListener } from "./redux/OrderSlice";
 
const Home = lazy(() => import("./pages/Home"));
const PrivayPolicy = lazy(() => import("./pages/PrivayPolicy"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Signin = lazy(() => import("./pages/Signin"));
const Signup = lazy(() => import("./pages/Signup"));
const Cart = lazy(() => import("./pages/Cart"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const ProductListing = lazy(() => import("./pages/ProductListing"));
const ShippingAndFreight = lazy(() => import("./pages/ShippingAndFreight"));
const MyAccount = lazy(() => import("./pages/MyAccount"));
const SpecialOrder = lazy(() => import("./pages/SpecialOrder"));
const Favourites = lazy(() => import("./pages/Favourites"));
 
// ─────────────────────────────────────────────────────────────────────────────
// ActivityTracker — listens to every click on the page and calls
// POST /api/activity/click to increment the user's activity count.
//
// Rules (handled on backend):
// - Only increments if user is logged in (token present)
// - Only increments if user has NOT placed an order (hasOrdered = false)
// - Once hasOrdered = true → backend ignores all calls, shows N/A in admin
// ─────────────────────────────────────────────────────────────────────────────
function ActivityTracker() {
  const { token, user } = useSelector((state) => state.Auth);
 
  useEffect(() => {
    // Don't attach listener if user is not logged in
    if (!token || !user) return;
 
    const handleClick = () => {
      fetch("https://doller-empire.onrender.com/api/activity/click", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).catch(() => {}); // silent fail — never show error to user
    };
 
    document.addEventListener("click", handleClick);
 
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [token, user]); 
 
  return null; // renders nothing
}
 
function App() {
  const { showProductDetailsPopup } = useSelector((state) => state.globalStates);
  const { token, user } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
 
  useEffect(() => {
    dispatch(loginAllTabsEventListener());
    dispatch(logoutAllTabsEventListener());
    dispatch(OrderAllTabsEventListener());
    dispatch(handleGetCategory());
    dispatch(handleGetSubCategory());
    dispatch(handleGetNewArrivals({ token }));
    dispatch(handleGetBanners());
    dispatch(handleGetContactUsDetails());
    dispatch(handleGetAllProducts({ token }));
    const response = dispatch(handleGetTopSellers({ token }));
    if (response) {
      response.then((res) => {
        if (
          res.payload?.status === "fail" &&
          (res.payload?.message === "Please login first." ||
            res.payload?.message === "Please provide authentication token.")
        ) {
          dispatch(handleLogoutReducer());
          dispatch(handleLogout());
        } else if (res.payload?.status === "fail") {
          toast.error(res.payload?.message);
        }
      });
    }
 
    if (user !== null) {
      const response = dispatch(handleGetVisitCount({ token }));
      if (response) {
        response.then((res) => {
          if (
            res.payload?.status === "fail" &&
            (res.payload?.message === "Please login first." ||
              res.payload?.message === "Please provide authentication token.")
          ) {
            dispatch(handleLogoutReducer());
            dispatch(handleLogout());
          } else if (res.payload?.status === "fail") {
            toast.error(res.payload?.message);
          }
        });
      }
    }
    if (!window.navigator.onLine) {
      toast.error("Check your internet connection", { duration: "5000" });
    }
  }, []);
 
  useEffect(() => {
    if (user !== null) {
      const response = dispatch(handleGetCart({ token }));
      if (response) {
        response.then((res) => {
          if (
            res.payload?.status === "fail" &&
            (res.payload?.message === "Please login first." ||
              res.payload?.message === "Please provide authentication token.")
          ) {
            dispatch(handleLogoutReducer());
            dispatch(handleLogout());
          } else if (res.payload?.status === "fail") {
            toast.error(res.payload?.message);
          } else if (res.payload?.status === "success") {
            localStorage.setItem("cartItems", JSON.stringify(res.payload.items));
          }
        });
      }
    }
  }, [user, token]);
 
  return (
<BrowserRouter>
<ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => { window.location.reload(); }}
>
<ScrollToTop />
 
        {/* Activity tracker — must be inside BrowserRouter, fires on every click */}
<ActivityTracker />
 
        <Suspense
          fallback={
<div className="relative top-0 left-0 w-screen h-screen">
<Lottie
                style={{ pointerEvents: "none", height: "300px", width: "300px" }}
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-screen h-full"
                animationData={loading}
                loop
              />
</div>
          }
>
          {showProductDetailsPopup && <ProductDetailPopup />}
<Header />
<Routes>
<Route path="/" element={<Home />} caseSensitive />
<Route path="/about-us" element={<AboutUs />} caseSensitive />
<Route path="/contact-us" element={<ContactUs />} caseSensitive />
<Route path="/privacy-policy" element={<PrivayPolicy />} caseSensitive />
<Route path="/sign-in" element={<Signin />} caseSensitive />
<Route path="/sign-up" element={<Signup />} caseSensitive />
<Route
              path="/cart"
              element={<PrivateRoute><Cart /></PrivateRoute>}
              caseSensitive
            />
<Route path="/product-listing/:title" element={<ProductListing />} caseSensitive />
<Route
              path="/favourites"
              element={<PrivateRoute><Favourites /></PrivateRoute>}
              caseSensitive
            />
<Route path="/special-order" element={<SpecialOrder />} caseSensitive />
<Route path="/forgot-password" element={<ForgotPassword />} caseSensitive />
<Route path="/reset-password" element={<ResetPassword />} caseSensitive />
<Route
              path="/my-account"
              element={<PrivateRoute><MyAccount /></PrivateRoute>}
              caseSensitive
            />
<Route path="/shipping-&-freight" element={<ShippingAndFreight />} caseSensitive />
<Route path="/*" element={<PageNotFound />} />
</Routes>
<Footer />
</Suspense>
</ErrorBoundary>
</BrowserRouter>
  );
}
 
export default App;